(function ($) {
	"use strict";

	/*=============================================
    =                Swiper Slider                =
    =============================================*/
    $('[hp-slider]').each(function () {
      var SwiperCarousel = $(this),
        getDataAttr = function(attr, defaultValue) {
          var value = SwiperCarousel.data(attr);
          return (value !== undefined && value !== null) ? value : defaultValue;
        },
        // Check if autoplay is enabled and configure accordingly
        autoplayConfig = getDataAttr('autoplay', false) ? { delay: 5000 } : false,
        swiperConfig = {
          slidesPerView: getDataAttr('items', 1),
          loop: getDataAttr('loop', true),
          speed: getDataAttr('speed', 600),
          lazy: getDataAttr('lazy', true),
          spaceBetween: parseInt(getDataAttr('space-between', 20)),
          navigation: {
            nextEl: SwiperCarousel.data('next'),
            prevEl: SwiperCarousel.data('prev'),
          },
          fadeEffect: { crossFade: true },
          autoplay: autoplayConfig,
          breakpoints: {
            480: {
              slidesPerView: getDataAttr('sm-items', 1),
              loop: getDataAttr('sm-loop', true),
              autoplay: getDataAttr('sm-autoplay', false) ? { delay: 5000 } : false,
              spaceBetween: parseInt(getDataAttr('sm-space-between', 20)),
            },
            750: {
              slidesPerView: getDataAttr('md-items', 1),
              loop: getDataAttr('md-loop', true),
              autoplay: getDataAttr('md-autoplay', false) ? { delay: 5000 } : false,
              spaceBetween: parseInt(getDataAttr('md-space-between', 20)),
            },
            991: {
              slidesPerView: getDataAttr('lg-items', 1),
              loop: getDataAttr('lg-loop', true),
              autoplay: getDataAttr('lg-autoplay', false) ? { delay: 5000 } : false,
              spaceBetween: parseInt(getDataAttr('lg-space-between', 20)),
            },
          },
        };
    
      new Swiper(SwiperCarousel[0], swiperConfig);
    });

      
    // Click event for Tab Heading
    $(".hp-tab-link").click(function(e) {
      e.preventDefault();
    
      // Reference to the clicked element
      var $this = $(this);
    
      // Remove "active" class from all panels and links within the same tab wrapper
      $this.closest('.tab--wrapper').find('.hp-tab__panel').removeClass("active");
      $this.closest('.tab--wrapper').find('.hp-tab-link').removeClass("active");
    
      // Toggle the "active" class for the clicked tab link
      $this.toggleClass("active");
    
      // Toggle the "active" class for the corresponding tab panel
      var targetPanel = $($this.attr("href"));
      targetPanel.toggleClass("active");
    });

    // Helper function to enforce Grass Samples limit
    async function enforceGrassSamplesLimit(grassSamples, maxLimit = 3) {
      let totalGrassCount = grassSamples.reduce((total, item) => total + item.quantity, 0);
      if (totalGrassCount <= maxLimit) return;

      const updates = {};
      let remainingQuantity = maxLimit;

      // Distribute the allowed quantity across items
      for (const item of grassSamples) {
        if (remainingQuantity <= 0) {
          updates[item.key] = 0; // Remove this item
        } else {
          const itemQuantity = Math.min(item.quantity, remainingQuantity);
          updates[item.key] = itemQuantity;
          remainingQuantity -= itemQuantity;
        }
      }

      // Update the cart
      await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates })
      });

      // Recheck the cart to ensure the limit is enforced
      const cartData = await (await fetch(window.Shopify.routes.root + "cart.js")).json();
      const newGrassSamples = cartData.items.filter(i => i.product_type === "Grass Samples");
      totalGrassCount = newGrassSamples.reduce((total, item) => total + item.quantity, 0);

      if (totalGrassCount > maxLimit) {
        // Recursively enforce the limit if still exceeded
        await enforceGrassSamplesLimit(newGrassSamples, maxLimit);
      }
    }

    // ADD TO CART (jQuery handler for [product-add-to-cart])
    $(document).ready(function () {
      let isUpdating = false; // Flag to prevent multiple clicks

      $("body").on("click", "[product-add-to-cart]", async function (e) {
        e.preventDefault();
        if (isUpdating) return; // Prevent action if an update is in progress

        isUpdating = true;
        const Button = $(this).find('button[type="submit"]');
        if (Button.length) {
          Button.prop("disabled", true).text("Adding...");
        }

        const ProductVariant = $(this).attr("data-variant"),
              ProductType = $(this).attr("data-type"),
              FormData = { items: [{ id: ProductVariant, quantity: 1 }] };

        try {
          const CartData = await (await fetch(window.Shopify.routes.root + "cart.js")).json();
          let GrassSamples = CartData.items.filter(i => i.product_type === "Grass Samples");
          let TotalGrassCount = GrassSamples.reduce((total, item) => total + item.quantity, 0);

          if (ProductType === "Grass Samples" && TotalGrassCount >= 3) {
            alert("You can only add up to 3 'Grass Samples' per order.");
            await enforceGrassSamplesLimit(GrassSamples);
            isUpdating = false;
            if (Button.length) {
              Button.prop("disabled", false).text("Get your Sample");
            }
            return;
          }

          await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(FormData),
          });

          // Recheck the cart after adding the item
          const UpdatedCartData = await (await fetch(window.Shopify.routes.root + "cart.js")).json();
          GrassSamples = UpdatedCartData.items.filter(i => i.product_type === "Grass Samples");
          TotalGrassCount = GrassSamples.reduce((total, item) => total + item.quantity, 0);

          if (ProductType === "Grass Samples" && TotalGrassCount > 3) {
            alert("Cart adjusted to include only 3 Grass Samples.");
            await enforceGrassSamplesLimit(GrassSamples);
          }

          window.location.href = "/cart";
        } catch (Err) {
          alert(Err.message);
          console.error("Error:", Err);
        } finally {
          isUpdating = false;
          if (Button.length) {
            Button.prop("disabled", false).text("Get your Sample");
          }
        }
      });
    });

})(jQuery);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.scroll-down--location').forEach(link => {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      const href = this.getAttribute('href');
      const targetId = href.includes('#') ? href.split('#')[1] : null;

      if (targetId) {
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const offsetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        } else {
          // Redirect to the link if target is not found
          window.location.href = href;
        }
      }
    });
  });

  // Helper function to enforce Grass Samples limit (shared with jQuery section)
  async function enforceGrassSamplesLimit(grassSamples, maxLimit = 3) {
    let totalGrassCount = grassSamples.reduce((total, item) => total + item.quantity, 0);
    if (totalGrassCount <= maxLimit) return;

    const updates = {};
    let remainingQuantity = maxLimit;

    // Distribute the allowed quantity across items
    for (const item of grassSamples) {
      if (remainingQuantity <= 0) {
        updates[item.key] = 0; // Remove this item
      } else {
        const itemQuantity = Math.min(item.quantity, remainingQuantity);
        updates[item.key] = itemQuantity;
        remainingQuantity -= itemQuantity;
      }
    }

    // Update the cart
    await fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates })
    });

    // Recheck the cart to ensure the limit is enforced
    const cartData = await (await fetch(window.Shopify.routes.root + "cart.js")).json();
    const newGrassSamples = cartData.items.filter(i => i.product_type === "Grass Samples");
    totalGrassCount = newGrassSamples.reduce((total, item) => total + item.quantity, 0);

    if (totalGrassCount > maxLimit) {
      // Recursively enforce the limit if still exceeded
      await enforceGrassSamplesLimit(newGrassSamples, maxLimit);
    }
  }

  // ADD TO CART (Vanilla JS handler for .cart-add--sample[data-variant])
  let isUpdating = false; // Flag to prevent multiple clicks

  document.querySelectorAll(".cart-add--sample[data-variant]").forEach(Button => {
    Button.addEventListener("click", async function (e) {
      e.preventDefault();
      if (isUpdating) return; // Prevent action if an update is in progress

      isUpdating = true;
      if (Button) {
        Button.disabled = true;
        Button.textContent = "Adding...";
      }

      const ProductVariant = Button.getAttribute("data-variant"),
            ProductType = Button.getAttribute("data-type"),
            FormData = { items: [{ id: ProductVariant, quantity: 1 }] };

      try {
        const CartData = await (await fetch(window.Shopify.routes.root + "cart.js")).json();
        let GrassSamples = CartData.items.filter(i => i.product_type === "Grass Samples");
        let TotalGrassCount = GrassSamples.reduce((total, item) => total + item.quantity, 0);

        if (GrassSamples && TotalGrassCount >= 3) {
          alert("You can only add up to 3 'Grass Samples' per order.");
          await enforceGrassSamplesLimit(GrassSamples);
          isUpdating = false;
          if (Button) {
            Button.disabled = false;
            Button.textContent = "Get a Sample";
          }
          return;
        }

        await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(FormData),
        });

        // Recheck the cart after adding the item
        const UpdatedCartData = await (await fetch(window.Shopify.routes.root + "cart.js")).json();
        GrassSamples = UpdatedCartData.items.filter(i => i.product_type === "Grass Samples");
        TotalGrassCount = GrassSamples.reduce((total, item) => total + item.quantity, 0);

        if (GrassSamples && TotalGrassCount > 3) {
          alert("Cart adjusted to include only 3 Grass Samples.");
          await enforceGrassSamplesLimit(GrassSamples);
        }

        window.location.href = "/cart";
      } catch (Err) {
        alert(Err.message);
        console.error("Error:", Err);
      } finally {
        isUpdating = false;
        if (Button) {
          Button.disabled = false;
          Button.textContent = "Get a Sample";
        }
      }
    });
  });
});